import React, { useEffect, useState } from "react";
import classes from "./bookingSection.module.css";
import BookingController from "./BookingController";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookingsByFilter } from "../../../../redux/slices/bookingSlice";
import HowBookingsWorkModal from "../../../../components/HowBookingsWorkModal";

const BookingSection = () => {
  const [selectedTab, setSelectedTab] = useState("confirmed");
  const [showWorkflowModal, setShowWorkflowModal] = useState(false);
  const dispatch = useDispatch();
  const { bookingsLoading } = useSelector((state) => state.booking);

  useEffect(() => {
    dispatch(
      fetchBookingsByFilter({
        type: "artist", // to be taken from token
        status: selectedTab,
      })
    );
  }, [selectedTab, dispatch]);

  return (
    <div className={classes.outerMostContainer}>
      <div className={classes.headerProfileSection}>
        <div className={classes.headerTop}>
          <p className={classes.profileTxt}>{"Bookings"}</p>
          <button
            className={classes.howItWorksButton}
            onClick={() => setShowWorkflowModal(true)}
          >
            How Bookings Work
          </button>
        </div>
        <div className={classes.headerLowerPart}>
          <div className={classes.leftSideNavigation}>
            <div
              className={`${classes.selectionTab} ${
                selectedTab === "confirmed" ? classes.activeTab : ""
              }`}
              onClick={() => setSelectedTab("confirmed")}
            >
              Upcoming
            </div>
            <div
              className={`${classes.selectionTab} ${
                selectedTab === "completed" ? classes.activeTab : ""
              }`}
              onClick={() => setSelectedTab("completed")}
            >
              Completed
            </div>
            <div
              className={`${classes.selectionTab} ${
                selectedTab === "pending_approval" ? classes.activeTab : ""
              }`}
              onClick={() => setSelectedTab("pending_approval")}
            >
              Pending Approval
              {selectedTab !== "pending_approval" && (
                <div className={classes.tabTooltip}>Respond within 24hrs</div>
              )}
            </div>

            <div
              className={`${classes.selectionTab} ${
                selectedTab === "awaiting_full_payment" ? classes.activeTab : ""
              }`}
              onClick={() => setSelectedTab("awaiting_full_payment")}
            >
              Awaiting Payment
            </div>
          </div>

          <div className={classes.infoSection}>
            <button
              className={classes.infoButton}
              onClick={() => setShowWorkflowModal(true)}
            >
              <span className={classes.infoIcon}>ℹ️</span>
            </button>
          </div>
        </div>
        <div className={classes.horizontalRule}></div>
      </div>

      <div className={classes.mainContainer}>
        {!bookingsLoading && (
          <div>
            {selectedTab === "pending_approval" && (
              <div className={classes.reminderBanner}>
                <p>
                  Remember: You have <strong>24 hours</strong> to respond to
                  booking requests
                </p>
                <button
                  className={classes.learnMoreButton}
                  onClick={() => setShowWorkflowModal(true)}
                >
                  Learn More
                </button>
              </div>
            )}
            <BookingController status={selectedTab} />
          </div>
        )}
      </div>

      {/* Booking Workflow Modal */}
      <HowBookingsWorkModal
        isOpen={showWorkflowModal}
        onClose={() => setShowWorkflowModal(false)}
      />
    </div>
  );
};

export default BookingSection;
